<div
  class="ui-selectable-card card card-bordered h-100"
  [class.ui-selectable-card--selected]="selected()"
  role="button"
  tabindex="0"
  (click)="toggleSelect.emit()"
  (keyup.enter)="toggleSelect.emit()"
>
  <div class="card-body d-flex align-items-center gap-3 p-4">
    @if (icon()) {
      <span
        class="ui-selectable-card__icon d-inline-flex align-items-center justify-content-center"
      >
        <i class="bi bi-{{ icon() }}"></i>
      </span>
    }
    <span class="fw-semibold fs-6 text-gray-800 flex-grow-1">
      {{ label() }}
    </span>
    <span
      class="ui-selectable-card__check d-inline-flex align-items-center justify-content-center"
      [class.ui-selectable-card__check--active]="selected()"
    >
      @if (selected()) {
        <i class="bi bi-check-lg"></i>
      }
    </span>
  </div>
</div>
